import { useSelector } from "src/redux/hooks";

export const useIsPendingWithdraw = (id?: string) => {
  const latestid = useSelector(state => state.generatorSlice.latestEntry.id);
  const pendingWithdraws = useSelector(
    state => state.pendingRequestsSlice.pendingWithdraws,
  );
  return pendingWithdraws.includes(id ?? latestid);
};
